// extracted by mini-css-extract-plugin
export default {"widgetContainer":"widgetContainer--WV3iY","hideFooter":"hideFooter--WV3iY","tpWidget_home":"tpWidget_home--WV3iY"};